module.exports = __webpack_public_path__ + "static/media/default-avatarF.f4821a73.png";